import Chip from '@mui/material/Chip';

import { useApp } from '@/presentation/hooks/use-app.js';
import { getStatusBadgeColor } from '@/shared/utils/format-status.js';

interface Props {
    status: string;
    label?: string;
}

export function StatusBadge({ status, label }: Props) {
    const { translate } = useApp();
    const color = getStatusBadgeColor(status);
    const text = label ?? translate(`statusLabels.${status}`);

    return <Chip label={text} color={color} size="small" variant="outlined" />;
}
